<div class="heatmap-editor symbol-editor" *ngIf="heatmapRenderer">
    <div class="clearfix legendWideControlGroup">
        <h4 class="ng-binding">Heatmap Options:</h4>
    </div>
    <br />
    <div class="clearfix legendWideControlGroup">
        <label>Pixel Intensity: {{ minPixelIntensity }} to {{ maxPixelIntensity }}</label>
        <div class="legendWideControlGroup">
            <kendo-rangeslider class="rangeslider" [(ngModel)]="rangeSliderValue"
                               [min]="0"
                               [max]="500"
                               [smallStep]="10"
                               [largeStep]="50">
            </kendo-rangeslider>
        </div>
    </div>
    <br />
    <div class="clearfix legendWideControlGroup">
        <label>Blur Radius:</label>
        <input class="form-control" type="number" [(ngModel)]="blurRadius" max="100" min="0" step="1" />
    </div>
    <br />
    <div class="clearfix legendWideControlGroup">
        <label>Colors: </label>
        <mc-color-picker-ng #colorPicker
                            class="color-swatch left"
                            [color]="startColorRamp"
                            (colorChange)="updateColorFromPicker($event, '1')">
        </mc-color-picker-ng>
        <!--<canvas #myCanvas id="myCanvas">Your browser does not support the HTML5 canvas tag.</canvas>-->
        <div class="myCanvas" #myCanvas></div>
        <mc-color-picker-ng #colorPicker
                            class="color-swatch right"
                            [color]="endColorRamp"
                            (colorChange)="updateColorFromPicker($event, '2')">
        </mc-color-picker-ng>

    </div>
    <br />
    <div class="clearfix legendWideControlGroup">
        <label>Heatmap Mode</label>
        <fieldset class="radio-group">
            <input class="radio-group-input" type="radio" [id]="'off'" name="off" value="off" [(ngModel)]="heatmapMode" (ngModelChange)="onHeatmapModeChange()" />
            <label class="radio-group-label" [for]="'off'">Off</label>
            <input class="radio-group-input" type="radio" [id]="'on'" name="on" value="on" [(ngModel)]="heatmapMode" (ngModelChange)="onHeatmapModeChange()" />
            <label class="radio-group-label" [for]="'on'">On</label>
            <input class="radio-group-input" type="radio" [id]="'auto'" name="auto" value="auto" [(ngModel)]="heatmapMode" (ngModelChange)="onHeatmapModeChange()" />
            <label class="radio-group-label" [for]="'auto'">Auto</label>
        </fieldset>
    </div>
</div>
